import { Api } from '../base/Api';
import { Injectable } from '@angular/core';
import { UserCompany } from 'src/app/models/UserCompany';
@Injectable({
    providedIn: 'root'
})
export class UserCompanyApi extends Api<UserCompany>{
}